// Configuración de Multi-Tenancy (Simplificado para Usuario Único)
export interface TenantConfig {
  id: string;
  name: string;
  projectId: string;
  domain: string;
  firebaseConfig: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId?: string;
  };
}

export const TENANTS: Record<string, TenantConfig> = {
  'default': {
    id: 'default',
    name: 'SodAsist',
    projectId: 'sodapp-5cb8a',
    domain: 'localhost',
    firebaseConfig: {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
    }
  }
};

// Función para detectar el tenant actual (siempre devuelve el default para usuario único)
export const getCurrentTenant = (): TenantConfig => {
  return TENANTS.default;
};

// Función para obtener la ruta de colección con tenant (se mantiene por compatibilidad de base de datos)
export const getTenantCollectionPath = (collectionName: string): string => {
  const currentTenant = getCurrentTenant();
  return `tenants/${currentTenant.id}/${collectionName}`;
};

// Función para obtener el ID del tenant actual
export const getCurrentTenantId = (): string => {
  return 'default';
};

// Función para obtener configuración de Firebase del tenant actual
export const getTenantFirebaseConfig = () => {
  return TENANTS.default.firebaseConfig;
};

// Función para cambiar de tenant (desactivada en modo monousuario)
export const switchTenant = (_tenantId: string) => {
  return TENANTS.default;
};

